// AUTO GENERATED FILE - Changes WILL be lost.
// ko - used as 'ko' fallback
export const common_fallback = true

export const translations = {}
